import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4ac4f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-body py-3",
  style: {"height":"32vh"}
}
const _hoisted_2 = { class: "table-responsive tableFixHead" }
const _hoisted_3 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = {
  class: "min-w-100px",
  style: {"margin-left":"15px"}
}
const _hoisted_6 = { style: {"margin-left":"15px"} }
const _hoisted_7 = { class: "min-w-120px" }
const _hoisted_8 = { class: "min-w-140px" }
const _hoisted_9 = { class: "min-w-120px" }
const _hoisted_10 = { class: "min-w-120px" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "min-w-100px text-left",
  "data-v-75a77c17": ""
}, null, -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { style: {"border-radius":"10px 0 0 10px"} }
const _hoisted_14 = {
  class: "text-dark fw-bolder fs-6",
  style: {"margin-left":"15px"}
}
const _hoisted_15 = {
  href: "#",
  class: "badge badge-pill badge-dark"
}
const _hoisted_16 = { class: "badge badge-pill badge-primary" }
const _hoisted_17 = {
  href: "#",
  class: "badge badge-pill badge-info"
}
const _hoisted_18 = {
  href: "#",
  class: "badge badge-pill badge-info"
}
const _hoisted_19 = {
  style: {"border-radius":"0 10px 10px 0","padding-right":"20px"},
  class: "text-end"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "badge badge-pill rounded-pill badge-secondary",
  style: {"font-size":"15px","padding-left":"13px","padding-right":"16px"}
}
const _hoisted_22 = {
  class: "svg-icon svg-icon-4",
  style: {"margin-left":"10px"}
}
const _hoisted_23 = {
  key: 0,
  class: "text-center fw-bolder",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("date")), 1)
              ]),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("type")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("cause")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("generalData.nameInjured")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("generalData.age")), 1),
              _hoisted_11
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass(_ctx.active_row == index ? 'activeRow' : ''),
                style: _normalizeStyle(index % 2 ? 'background-color:#dff5ff' : ''),
                onClick: ($event: any) => (
                  _ctx.isLoading || _ctx.active_row == index
                    ? ''
                    : _ctx.clickTR(item['ImageUUID'], index)
                )
              }, [
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(new Date(item.OccurrenceDateTime).toLocaleString(
                        "es-ES",
                        {
                          timeZone: "Europe/Madrid",
                        }
                      )), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t(
                      `typelandIncident.${_ctx.getTextType(item.LandIncidentTypeID)}`
                    ).slice(0, 25)), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(
                      `causeIncidents.${_ctx.getTextCause(item.LandIncidentCauseID)}`
                    ).slice(0, 25)), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.VictimName), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.VictimAge), 1)
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("div", {
                    style: {"display":"inline-flex","vertical-align":"middle"},
                    class: "text-end",
                    onClick: _withModifiers(($event: any) => (_ctx.editIncident(item)), ["stop"])
                  }, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, [
                        _createVNode(_component_inline_svg, { src: "media/icons/art005.svg" })
                      ])
                    ])
                  ], 8, _hoisted_20)
                ])
              ], 14, _hoisted_12))
            }), 128))
          ])
        ]),
        (_ctx.list.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t("noResultsDates")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}